import * as d3 from 'd3-selection'

export default function (selection, defs, gantt) {
  selection.each(function (d) {
    var container = d3.select(this)
      , outer = container.selectAll('rect.gantt-item-milestone')     // Draw the main outer diamond
                         .data(d => {
                           return [d].filter(_d => _d.endDate)
                         })
      , enter = outer.enter()
                     .append('rect')
      , height = gantt.dimensions.milestone.height
      , padding = gantt.dimensions.milestone.padding

    outer.merge(enter)
         .attr('class', 'gantt-item-milestone main-shape')
         .attr('height', height)
         .attr('width', height)
         .attr('transform', function (d) {
           return `translate(${-height / 2}, ${padding}) rotate(45 ${height / 2} ${height / 2})`
         })

    // Now the inner rect if the milestone is behind schedule and complete
    var inner = container.selectAll('rect.gantt-item-milestone-behind')
                         .data(d => {
                           return d.scheduleStatus.startsWith('behind') && d.state == 'gantt-item-complete' ? [d] : []
                         })
      , innerHeight = 10.25

    inner.enter()
         .append('rect')
         .attr('height', innerHeight)
         .attr('width', innerHeight)
         .attr('transform', function (d) {
           return `translate(${-innerHeight / 2}, ${padding + (height / 2) - (innerHeight / 2)}) rotate(45 ${innerHeight / 2} ${innerHeight / 2})`
         })
         .merge(inner)
         .attr('class', d => {
           return `gantt-item-milestone-behind gantt-item-milestone-${d.scheduleStatus}` // `behind-red` or `behind-yellow`
         })

    inner.exit()
         .remove()
  })
}
